import React, { FunctionComponent } from 'react';

import Title from '../../../../components/Title';
import CardBox from '../../../../components/CardBox';
import OrderTotal from '../../../../components/OrderTotal';
import PaymentCard from '../../../../components/PaymentCard';
import { Order } from '../../../../requests/caipirinha-api/interfaces/order.interface';
import { toBRL } from '../../../../utils/money.util';
import IcCard from '../../../../assets/icons/ic_card.svg';
import paymentHelpers from './helpers';
import CreditCardWithInterest from '../../../../components/CreditCardWithInterest';
import { PaymentMethodType } from '../../../../constants/paymentMethodType.enum';

interface Props {
  order: Order;
}

const Payment: FunctionComponent<Props> = ({ order }) => {
  const { products, services, shipping, payments, card } = order.details;

  const sumOfProductsValues = paymentHelpers.getSumOfProductsValues(products);
  const numberOfServices = paymentHelpers.getNumberOfServices(services, products);
  const sumOfAllServicesValue = paymentHelpers.getSumOfAllServicesValue(services, products);
  const assemblyTotal = paymentHelpers.getAssemblyTotal(products);
  const shippingValue = paymentHelpers.getShippingValue(shipping);

  const simulatedPayment = payments[0].type === PaymentMethodType.CARD &&
    payments[0].simulated
    ? payments[0] : null;

  return (
    <>
      <Title icon={IcCard}>
        Resumo do Pagamento
      </Title>
      <CardBox>
        <div className="details" data-cy='products-price'>
          <p className="medium">
            Produtos (
            {products && products.reduce(
              (prev, curr) => prev + curr.quantity,
              0,
            )}
            )
          </p>
          <strong>{toBRL(sumOfProductsValues)}</strong>
        </div>

        {numberOfServices > 0 && (
          <div className="details" data-cy='services-price'>
            <p className="medium">Serviços ({numberOfServices})</p>
            <strong>{toBRL(sumOfAllServicesValue)}</strong>
          </div>
        )}

        {assemblyTotal > 0 && (
          <div className="details">
            <p className="medium">Montagem</p>
            <strong>{toBRL(sumOfAllServicesValue)}</strong>
          </div>
        )}

        <div className="details" data-cy='shipment-price'>
          <p className="medium">Frete</p>
          <strong>
            {shippingValue > 0
              ? toBRL(shippingValue)
              : 'Grátis'}
          </strong>
        </div>
        <hr />
        <OrderTotal payments={payments} hasSimulated={!!simulatedPayment}/>
      </CardBox>

      { simulatedPayment &&
        <CardBox>
          <CreditCardWithInterest paymentCard={simulatedPayment}/>
        </CardBox>
      }

      {card && <PaymentCard card={card} />}
    </>
  );
};

export default Payment;
